import { Button, Typography } from "@altimateai/lego";
import pageNotFound from "../../assets/images/404.png";
import { Stack } from "@altimateai/lego";
import { IconArrowLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

export const SomethingWrong = () => {
  let navigate = useNavigate();

  return (
    <>
      <Stack justify={"center"} align={"center"} className={"al-min-h-full al-min-w-full"}>
        <Stack
          align={"stretch"}
          gap="none"
          direction={"row"}
          className={"al-px-8 al-py-6 al-rounded-md al-bg-white"}
        >
          <Stack gap={"none"} justify={"center"} direction={"column"} className={"al-mr-10"}>
            <Button
              variant={"ghost"}
              size={"xs"}
              className={"al-self-start al-justify-self-start"}
              onClick={() => {
                navigate(-1);
              }}
            >
              <IconArrowLeft />
              Go Back
            </Button>
            <Stack gap={"none"} direction={"column"} className={"al-mb-4"}>
              <Typography weight={"semibold"} variant={"h1"} className={"al-mb-3 al-text-red-700"}>
                Oops!
              </Typography>
              <Typography weight={"semibold"} variant={"h3"} className={"al-mb-3"}>
                Something went wrong
              </Typography>
              <Stack direction={"column"} gap={"xs"}>
                <Typography className="al-max-w-lg al-text-muted-foreground">
                  We are experiencing a technical issue. Please refresh the page or go back and try
                  again. If the problem persists, contact our support team.
                </Typography>
              </Stack>
              <Stack className={"al-mt-4 al-w-full"} gap={"md"} direction={"row"}>
                <Button onClick={() => window.location.reload()}>Reload Page</Button>
                <Button
                  variant={"outline"}
                  onClick={() => {
                    window.Intercom?.("show");
                  }}
                >
                  Contact Us
                </Button>
              </Stack>
            </Stack>
          </Stack>
          <img src={pageNotFound} alt="Internal error" />
        </Stack>
      </Stack>
    </>
  );
};
